export const parseQueryAttributeFilters = (
  query: string
): Record<string, string[]> => {
  const filters = {};
  if (query == null || query === '') {
    return filters;
  }
  const propsWithValues = query.split('.').filter((n) => n);
  propsWithValues.map((value) => {
    const propWithValues = value.split('_').filter((n) => n);
    filters[propWithValues[0]] = propWithValues.slice(1);
  });
  return filters;
};

export const serializeQueryAttributeFilters = (
  values: Record<string, string[]>
): string => {
  const str = [];
  Object.keys(values).forEach((value) => {
    str.push(`${value}_${values[value].join('_')}`);
  });
  return str.join('.');
};

export const sortProjectsByCreationDate = (projectList) =>
  /* if there is a 'sort order' field, sort such projects in descending order
    if there is a 'creation date, - sort such projects in descending order also
    otherwise list all the rest in any order
  */
  projectList.slice().sort((a, b) => {
    const { sort_order: A_SO, creation_date: A_CD } = a.node;
    const { sort_order: B_SO, creation_date: B_CD } = b.node;

    if (A_SO && B_SO) {
      return A_SO - B_SO;
    }

    if (A_SO && !B_SO) {
      return -1;
    }

    if (!A_SO && B_SO) {
      return 1;
    }

    if (A_CD && B_CD) {
      return new Date(B_CD).getTime() - new Date(A_CD).getTime();
    }

    if (A_CD && !B_CD) {
      return -1;
    }

    if (!B_CD && A_CD) {
      return 1;
    }
  });
